import React from 'react';
import classnames from 'classnames/bind';
import { bool, object, func, number, string, } from 'prop-types';

import MediaPlayer from 'common/MediaPlayer/MediaPlayer';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';

import styles from './RightSide.css';

const cx = classnames.bind(styles);
const imgPlaceholder = require('assets/images/utils/transparent.png');

const RightSide = ({
  colorScheme,
  mediaSlide,
  isPlaying,
  togglePlay,
  withCarousel,
  activeSlide,
  handleCarousel,
  totalSlides,
  autoplay,
  typeB
}) => {
  const { youtubeVideoId, srcUrl, imageUrl, thumbnail } = mediaSlide;
  const darkBackgrounds = colorScheme === 'lb02' || colorScheme === 'lb04';

  return (
    <div className={cx('section', { typeA: !typeB })}>
      <div className={styles.slide}>
        <img src={imgPlaceholder} width='100%' />
        <MediaPlayer
          className={styles.mediaFrame}
          playing={isPlaying}
          youtubeId={youtubeVideoId}
          srcUrl={srcUrl}
          imageUrl={imageUrl}
          onClick={imageUrl ? undefined : togglePlay}
          onEnded={togglePlay}
          thumbnail={thumbnail}
        />
        {
          withCarousel && (
            <CarouselPagination
              className={styles.carouselPagination}
              autoplay={autoplay && !isPlaying}
              totalItems={totalSlides}
              currentPage={activeSlide}
              onPageChange={handleCarousel}
              medium={!darkBackgrounds}
              dark={darkBackgrounds}
            />
          )
        }
      </div>
    </div>
  );
};

RightSide.propTypes = {
  activeSlide: number,
  autoplay: bool,
  colorScheme: string,
  handleCarousel: func,
  isPlaying: bool,
  mediaSlide: object,
  togglePlay: func,
  totalSlides: number,
  typeB: bool,
  withCarousel: bool,
};

RightSide.displayName = 'RightSide';

export default RightSide;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/MediaBanner/RightSide/RightSide.js